const TIME_WINDOW_BUFFER_SECONDS = 15 * 60; // 15 minutes
/**
 * Converts a timestamp (ISO 8601 string or epoch milliseconds) to epoch seconds.
 * Returns `undefined` when the timestamp is missing or unparseable.
 */
const toEpochSeconds = (timestamp: string | number | null | undefined): number | undefined => {
	if (timestamp === null || timestamp === undefined || timestamp === '') {
		return undefined;
	}

	const ms = typeof timestamp === 'number' ? timestamp : new Date(timestamp).getTime();

	if (Number.isNaN(ms)) {
		return undefined;
	}

	return Math.floor(ms / 1000);
};

/**
 * Builds the `&earliest=...&latest=...` params for an absolute Splunk time window
 * around the given timestamp, or an empty string when no timestamp is available.
 */
export const getSplunkTimeRangeParams = (timestamp: string | number | null | undefined): string => {
	const epochSeconds = toEpochSeconds(timestamp);

	if (epochSeconds === undefined) {
		return '';
	}

	const earliest = epochSeconds - TIME_WINDOW_BUFFER_SECONDS;
	const latest = epochSeconds + TIME_WINDOW_BUFFER_SECONDS;
	return `&earliest=${earliest}&latest=${latest}`;
};
